<template>
    <div class="semiPieChart" ref="semiPieChart"></div>
</template>

<script>
// importing AMCharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
//default theme for AMcharts
am4core.useTheme(am4themes_animated);
export default {
    name: 'semi-pie-chart',
    data() {
        return {
            data: null,
        }
    },
    methods: {
        getSemiPieChartData() {
            axios
                .get("dashboard/semipiechart")
                .then((response) => {
                    this.data = response.data;
                    this.moduleWiseSemiPieChart();
                })
                .catch((error) => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        },
        moduleWiseSemiPieChart() {
            var chart = am4core.create(this.$refs.semiPieChart, am4charts.PieChart);
            // chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            chart.data = this.data;

            chart.radius = am4core.percent(70);
            chart.innerRadius = am4core.percent(40);
            chart.startAngle = 180;
            chart.endAngle = 360;


            var series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "value";
            series.dataFields.category = "module";

            series.slices.template.cornerRadius = 10;
            series.slices.template.innerCornerRadius = 7;
            series.slices.template.draggable = true;
            series.slices.template.inert = true;
            series.alignLabels = true;

            series.hiddenState.properties.startAngle = 90;
            series.hiddenState.properties.endAngle = 90;

            chart.legend = new am4charts.Legend();
        },
    },
    mounted() {
        this.getSemiPieChartData();

    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
}
</script>

<style lang="sass" scoped>

</style>
